'use client';

import React, { useEffect, useState } from 'react';
import { Sidebar } from '@/app/Components/Element_Components/siderMenu/SideMenu';
import Link from 'next/link';
import Breadcrumb from '@/app/Components/Element_Components/breadcrumb/breadcrumbElement';
import { getBaseUrl, getPublicBaseUrl } from '@/lib/getBaseURL';
import { useLanguage } from '@/app/LanguageContext';
import { useTranslate } from '@/utils/languageTranslation';
import { sanitizeIframeAllowAttributes } from '@/utils/sanitizeIframeAllow';

interface AboutData {
  title: string;
  text: string;
  image: {
    url: string;
    
  }
  name: string;
  intro: string;
  fullmessage: string;
}
interface LinkItem {
  href: string;
  name: string;
}

const initialAboutData: AboutData = {
  title: '',
  text: '<p>This is the initial hardcoded content for the About page.</p>',
  image: {
    url: 'https://example.com/image.jpg',
  },
  intro: "this is the intro of the president message",
  fullmessage: "this is the full message of the president",
  name: 'President Name', 
};


async function fetchAboutContent(language:string): Promise<AboutData | null> {
  try {
    const apiUrl = getBaseUrl();
    if (!apiUrl) {
      console.error("NEXT_PUBLIC_STRAPI_URL is not defined.");
      return null;
    }
    console.log(apiUrl)
    const response = await fetch(`${apiUrl}/api/president-message?populate=*?locale=${language}`); // Adjust endpoint and field name

    if (!response.ok) {
      console.error(`Failed to fetch About content. Status: ${response.status}`);
      return null;
    }

    const data = await response.json();

    if (data && data.data) {
      return { text: data.data.content, title: data.data.title, intro: data.data.intro, fullmessage: data.data.fullmessage, image: data.data.image, name: data.data.name }; // Adjust according to your API response structure
    } else {
      console.error("Invalid About content data structure:", data);
      return null;
    }
  } catch (error) {
    console.error("Error fetching About content:", error);
    return null;
  }
}

const CeoMessage = () => {
  const {t} = useTranslate()
  const {language} = useLanguage()
  const [AboutData, setAboutData] = useState<AboutData>(initialAboutData);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getAboutContent = async () => {
      setLoading(true);
      const fetchedData = await fetchAboutContent(language);
      if (fetchedData) {
        setAboutData(fetchedData);
      }
      setLoading(false);
    };

    getAboutContent();
  }, []);

  if (loading) {
    return <div className="py-8 text-center text-gray-500">Loading About Content...</div>;
  }

  const breadcrumbProps = [
    {
    label:`${t('home')}`,
    href:'/'
  },
  {
    label: `${t('about')}`,
    href:'/about'
  },
    {
      label:`${t('president_message')}`,
      href:'/about/president-message'
    },
  ]

  const sidebarLinks: LinkItem[] = [
  { href: '/about', name: `${t('about')}` },
  {href:'/about/vision',name:`${t('vision_and_mission')}`},
  {href:'/about/president-message', name: `${t('president_message')}` },
  {href:'/about/people',name:`${t('people')}`},
  {href:'/about/history',name:`${t('history')}`},
  { href: '/about/demography', name: `${t('geography')}` },
  { href: '/about/regional-structure', name: `${t('regional_structure')}` },
];
  
  return (
    <div className='mb-50'>
      <div className='max-w-[71rem] mx-auto px-5 xl:px-0'>
        <Breadcrumb links={breadcrumbProps}/>
        <div style={{ display: 'flex', flexDirection: 'row' }} className="max-w-[71rem] mt-10 mx-auto">
        <div className='lg:w-[16.3125rem] lg:h-[22.8rem] lg:mr-12'>
          <Sidebar links={sidebarLinks} />
        </div>
        <div className='md:mx-0 mx-2 md:mr-0 md:w-5xl'>
        <h1 className='text-lg md:text-3xl font-bold text-[#002B4E] md:mb-4 mb-2 mx-auto text-center'>{AboutData.title}</h1>
        {/* <div
          dangerouslySetInnerHTML={{ __html: sanitizeIframeAllowAttributes(AboutData.text || '') }}
          className=" max-w-5xl mx-auto pt-5 prose"
          style={{  }} 
        /> */}
        <div className='mb-10 text-[#4A4A4A]'>{AboutData.intro}</div>
        <img src={`${getPublicBaseUrl()}${AboutData.image.url}`} alt="" className='md:w-[36.5625rem] md:h-[26rem] rounded-lg mx-auto'/>
        <h2 className='text-xl font-bold text-[#002B4E] mx-auto text-center mt-5'>{AboutData.name}</h2>
        <div className='mt-5 text-[#4A4A4A]'>{AboutData.fullmessage}</div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default CeoMessage;